export const QR_TOOLTIP_STORE_NAME: string = 'mobile.education.qr.activityTimeline'
